import { cn } from '@/lib/tailwind.utils'

interface HomeContentProps {
  children: React.ReactNode
  className?: string
}

const SectionContent = ({ children, className }: HomeContentProps) => {
  return (
    <div className={cn('mx-auto w-full max-w-5xl lg:max-w-6xl xl:max-w-7xl px-6', className)}>
      {children}
    </div>
  )
}

export default SectionContent
